import initHelpHero, { HelpHero } from 'helphero';

let hlp: HelpHero;
let initialized = false;

export function helpHeroService(userData: any) {
  const { name, country, userId, managerProfile, selfManagement } = userData;
  if (!initialized && (managerProfile || selfManagement)) {
    hlp = initHelpHero('SpHwKAMvCGx');
    initialized = true;
  }
  if (hlp) {
    hlp.identify(userId, { name, country });
  }
}
